export const addClassToBody = (className = 'overlayed') => document.body.classList.add(className)
export const removeClassFromBody = (className = 'overlayed') =>
  document.body.classList.remove(className)
